import { object, z } from 'zod';

export const newMeetingSchema = z
  .object({
    comId: z.number({ required_error: 'Ce champs est obligatoire' }),
    object: z.string({ required_error: 'Ce champs est obligatoire' }),
    emplacement: z.string().max(100, 'Le contenu de ce champ ne doit pas dépasser 100 caractères.').optional(),
    reunionPpms: z.array(object({})).default([]),
    reunionDacs: z.array(object({})).default([]),
    reunionDemandes: z.array(object({})).default([]),
    reunionReports: z.array(object({})).default([]),
    participants: z.array(object({})).optional(),
  })
  .superRefine((data, ctx) => {
    const hasPpm = data.reunionPpms && data.reunionPpms.length > 0;
    const hasDac = data.reunionDacs && data.reunionDacs.length > 0;
    const hasDemandes = data.reunionDemandes && data.reunionDemandes.length > 0;
    const hasReports = data.reunionReports && data.reunionReports.length > 0;

    if (!hasPpm && !hasDac && !hasDemandes && !hasReports) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Vous devez sélectionner au moins un dossier PPM, DAC, Aditif ou Report pour pouvoir créer une réunion.',
        path: ['reunionPpms'],
      });
    }
  });
